var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checklist-templates" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "header-left" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("auto.checklistTemplates")))]),
          _vm._v(" "),
          _c("p", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.$t("auto.defineChecklistTemplatesForTasks"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "loading-container" },
            [_c("a-spin", { attrs: { size: "large" } })],
            1
          )
        : _c("div", { staticClass: "templates-container" }, [
            _c(
              "div",
              { staticClass: "templates-list" },
              _vm._l(_vm.templates, function (template) {
                return _c(
                  "div",
                  {
                    key: template.id,
                    staticClass: "template-card",
                    class: { "is-default": template.isDefault },
                  },
                  [
                    _c("div", { staticClass: "template-header" }, [
                      _c(
                        "div",
                        { staticClass: "template-header-left" },
                        [
                          _c("span", { staticClass: "template-name" }, [
                            _vm._v(_vm._s(template.name)),
                          ]),
                          _vm._v(" "),
                          template.isDefault
                            ? _c("a-tag", { attrs: { color: "green" } }, [
                                _vm._v(_vm._s(_vm.$t("auto.default"))),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "template-header-right" },
                        [
                          _c(
                            "a-tooltip",
                            {
                              attrs: {
                                title: template.isDefault
                                  ? "Varsayılandan kaldır"
                                  : "Varsayılan olarak ayarla",
                              },
                            },
                            [
                              _c(
                                "a-button",
                                {
                                  staticClass: "icon-button",
                                  class: { active: template.isDefault },
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setAsDefault(template.id)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v(
                                      _vm._s(
                                        template.isDefault
                                          ? "star"
                                          : "star_border"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticClass: "icon-button",
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.editTemplate(template)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("edit"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticClass: "icon-button",
                              attrs: {
                                type: "text",
                                size: "small",
                                danger: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.confirmDeleteTemplate(template)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "template-body" }, [
                      _c(
                        "div",
                        { staticClass: "items-preview" },
                        [
                          _vm._l(
                            template.items.slice(0, 5),
                            function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "item-row" },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("check_box_outline_blank"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.title))]),
                                ]
                              )
                            }
                          ),
                          _vm._v(" "),
                          template.items.length > 5
                            ? _c("div", { staticClass: "more-items" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t("auto.moreItemsCount", {
                                        count: template.items.length - 5,
                                      })
                                    ) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "add-template-btn",
                on: { click: _vm.createNewTemplate },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("add_circle"),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("auto.addNewTemplate")))]),
              ]
            ),
          ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.showEditor,
            title:
              _vm.editingTemplate && _vm.editingTemplate.id
                ? _vm.$t("task.checklistTemplateModalEdit")
                : _vm.$t("task.checklistTemplateModalNew"),
            width: "600px",
            footer: null,
            bodyStyle: { padding: "24px" },
            wrapClassName: "template-editor-modal",
          },
          on: { cancel: _vm.closeEditor },
        },
        [
          _vm.editingTemplate
            ? _c("div", { staticClass: "template-editor" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("auto.templateName")))]),
                    _vm._v(" "),
                    _c("a-input", {
                      attrs: {
                        placeholder: _vm.$t("auto.enterTemplateName"),
                        size: "large",
                      },
                      model: {
                        value: _vm.editingTemplate.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.editingTemplate, "name", $$v)
                        },
                        expression: "editingTemplate.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v(_vm._s(_vm.$t("auto.checklistItems")))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "items-list" },
                    _vm._l(_vm.editingTemplate.items, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "item-edit-row" },
                        [
                          _c(
                            "i",
                            { staticClass: "material-icons drag-handle" },
                            [_vm._v("drag_indicator")]
                          ),
                          _vm._v(" "),
                          _c("a-input", {
                            attrs: { placeholder: _vm.$t("auto.itemTitle") },
                            model: {
                              value: item.title,
                              callback: function ($$v) {
                                _vm.$set(item, "title", $$v)
                              },
                              expression: "item.title",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "text",
                                size: "small",
                                danger: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.removeItem(index)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v("close"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "add-item-btn", on: { click: _vm.addItem } },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("auto.addItem")))]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "a-checkbox",
                      {
                        model: {
                          value: _vm.editingTemplate.isDefault,
                          callback: function ($$v) {
                            _vm.$set(_vm.editingTemplate, "isDefault", $$v)
                          },
                          expression: "editingTemplate.isDefault",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("auto.setThisTemplateAsDefault")) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    _c("a-button", { on: { click: _vm.closeEditor } }, [
                      _vm._v(_vm._s(_vm.$t("auto.cancel"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        attrs: { type: "primary", disabled: !_vm.canSave },
                        on: { click: _vm.saveTemplate },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("auto.save")) + " ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }